import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { OpfoelgningDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/opfoelgning-dto';
import { AuthService } from 'src/app/services/auth.service';
import { OpfoelgningerService } from 'src/app/services/opfoelgninger.service';

@Component({
    selector: 'app-opfoelgning-button',
    templateUrl: './opfoelgning-button.component.html',
    styleUrls: ['./opfoelgning-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpfoelgningButtonComponent implements OnInit {
  @Input() opfoelgningList: OpfoelgningDto[];

  constructor(private opfoelgningerService: OpfoelgningerService, private auth: AuthService) {}

  ngOnInit(): void {}

  opfoelgninger(): string {
    return this.useropfolgninger()
      .map((o) => o.note)
      .join('\n');
  }

  useropfolgninger(): Array<OpfoelgningDto> {
    return this.opfoelgningList.filter((p) => p.user == this.auth.username);
  }

  button() {
    return this.opfoelgningerService.opfoelgningState(this.opfoelgningList, this.auth.username);
  }

  getToolTip(text: string) {
    const users = this.opfoelgningerService.otherUsers(this.opfoelgningList, this.auth.username);
    return text.replace('{users}', users);
  }
}
